import { Delivery } from "../domain/deliveries";
import { deliveryStore } from "../infrastructure/store/deliveryStore";
import { getDeliveryByIdService } from "../infrastructure/services/getDeliveryByIdService";

export const getDeliveryById = {
  async execute(deliveryId: string): Promise<Delivery> {
    if (!deliveryStore().matchArtwork(deliveryId)) {
      const delivery = await getDeliveryByIdService.execute(deliveryId);
      await deliveryStore().updateDeliverySession(delivery);
    }

    return deliveryStore().memoryDelivery;
  },
};


